{
  "CANNED_MGMT": {
    "HEADER": "Risposte predefinite",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Non ci sono elementi che corrispondono a questa richiesta.",
    "LIST": {
      "404": "Non ci sono risposte predefinite disponibili in questo account.",
      "TITLE": "Gestisci le risposte predefinite",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Contenuto",
        "INBOXES": "Caselle",
        "ACTIONS": "Azioni"
      },
      "ALL_INBOXES": "Tutte le caselle",
      "FILTER": {
        "ALL_INBOXES": "Tutte le caselle",
        "NO_INBOX": "Nessuna casella",
        "SEARCH_PLACEHOLDER": "Cerca caselle"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Oggetto (solo email)",
          "PLACEHOLDER": "Oggetto facoltativo per risposte email / nuove conversazioni"
        },
        "CONTENT": {
          "LABEL": "Messaggio",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Allegati"
        },
        "INBOXES": {
          "LABEL": "Caselle",
          "PLACEHOLDER": "Seleziona caselle (opzionale, lascia vuoto per tutte le caselle)"
        },
        "SUBMIT": "Invia"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Oggetto (solo email)",
          "PLACEHOLDER": "Oggetto facoltativo per risposte email / nuove conversazioni"
        },
        "CONTENT": {
          "LABEL": "Messaggio",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Il messaggio è obbligatorio."
        },
        "ATTACHMENTS": {
          "LABEL": "Allegati"
        },
        "INBOXES": {
          "LABEL": "Caselle",
          "PLACEHOLDER": "Seleziona caselle (opzionale, lascia vuoto per tutte le caselle)"
        },
        "SUBMIT": "Invia"
      },
      "BUTTON_TEXT": "Modifica",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
      },
      "CONFIRM": {
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
